import _ from 'lodash';
import dbImages from '../../config/databases/images';
import updateFormStatus from '../Form/updateFormStatus';

export async function checkImagesUploaded(formId, form) {
  const _formId = formId.toString();
  const missingImages = await dbImages.images
    .where('formId')
    .equals(_formId)
    .and((x) => x.status < 2)
    .toArray();
  const totalMissingImages = missingImages.length;
  if (totalMissingImages > 0) {
    let totalImages = await dbImages.images.where('formId').equals(_formId).toArray();
    totalImages = totalImages.length;
    await updateFormStatus(_formId, Math.round((1 - totalMissingImages / totalImages) * 100), 'imageStatus');
    return false;
  }
  if (_.get(form, 'imageStatus', null) !== 100) await updateFormStatus(_formId, 100, 'imageStatus');
  return true;
}
